import { useEffect } from "react";

import { useQuery } from "@otta/search/apollo";
import { CurrentUserDocument } from "@otta/search/schema";

declare global {
  interface Window {
    Cookiebot?: {
      hide: () => void;
      show: () => void;
    };
  }
}

export function useCookiebot(): null {
  const { data } = useQuery(CurrentUserDocument, { ssr: true });

  useEffect(() => {
    function listener() {
      if (data?.currentUser && typeof window.Cookiebot?.hide === "function") {
        window.Cookiebot?.hide();
      }
    }

    window.addEventListener("CookiebotOnDialogDisplay", listener);

    listener();

    return () => {
      window.removeEventListener("CookiebotOnDialogDisplay", listener);
    };
  }, [data?.currentUser]);

  return null;
}
